import type {Crop} from './housingModel';
export const DEFAULT_CROP:Crop={x:.5,y:.5,zoom:1};
/** Cover, never stretch. The editor and the room texture use the same source rectangle. */
export function cropRect(iw:number,ih:number,w:number,h:number,crop:Crop=DEFAULT_CROP){
 const ratio=Math.max(w/iw,h/ih)*crop.zoom,width=w/ratio,height=h/ratio;
 return {x:(iw-width)*crop.x,y:(ih-height)*crop.y,width,height};
}
export async function prepareImage(file:File):Promise<string>{
 if(!['image/png','image/jpeg','image/webp'].includes(file.type))throw Error('Choose a PNG, JPG or WebP image.');
 if(file.size>10*1024*1024)throw Error('Choose an image smaller than 10 MB.');
 const bitmap=await createImageBitmap(file);
 try{
  const factor=Math.min(1,1200/Math.max(bitmap.width,bitmap.height));
  const canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(bitmap.width*factor));canvas.height=Math.max(1,Math.round(bitmap.height*factor));
  const ctx=canvas.getContext('2d')!;ctx.fillStyle='#ffffff';ctx.fillRect(0,0,canvas.width,canvas.height);ctx.drawImage(bitmap,0,0,canvas.width,canvas.height);
  const image=canvas.toDataURL('image/jpeg',.8);if(image.length>800000)throw Error('Choose a smaller image.');return image;
 }finally{bitmap.close();}
}
